import React from 'react';
import { useTranslation } from 'react-i18next';
import CameraCaptureSC from '../camera-capture.styled';

function RotationInfo() {
  const { t } = useTranslation('components');
  return (
    <CameraCaptureSC>
      <div className="rotation-info">
        <div className="info-text">
          <h1>{t('rotationInfo.title')}</h1>
          <h2>{t('rotationInfo.subTitle')}</h2>
        </div>
      </div>
    </CameraCaptureSC>
  );
}

export default RotationInfo;
